import { sendLog as sendPcpAnalyticsLog } from '@/vendor/pcp-analytics'
import AddToCartButtonInListAdapterForTemplate from '@ajax/vue/components/organisms/addtocart/in-item-list/adapter/AddToCartButtnInListAdapterForTemplate.vue'
import { getConditionView } from '@ajax/vue/components/templates/item-list/condition/get-condition-view'
import Router, { Route, RouteConfig } from 'vue-router'

import ImageWithBadgeBand from '@/components/atoms/image/ImageWithBadgeBand.vue'
import ImageWithBorder from '@/components/atoms/image/ImageWithBorder.vue'
import Video from '@/components/atoms/video/Video.vue'
import VideoThumbnail from '@/components/atoms/video/VideoThumbnail.vue'
import ItemRating from '@/components/molecules/item/ItemRating.vue'
import Share from '@/components/organisms/Share.vue'
import { SessionService } from '@/services/session/session-service'
import { InstanceResolver } from '@/util/instanceResolver'

import BundlePurchaseContainer from '@/components/molecules/bundle-purchase/BundlePurchaseContainer.vue'
import BundleDiscountLabelWithStore from '@/components/molecules/discount/BundleDiscountLabelWithStore.vue'
import RecentlyViewed from '@/components/organisms/item-list/recently-viewed/ItemDetailRecentlyViewed.vue'
import PaidMembershipPrice from '@/components/organisms/item/price/paid-membership-price/PaidMembershipPrice.vue'
import SearchContactLens2 from '@/components/organisms/searchContactLens/SearchContactLens2.vue'
import SearchContactLens4 from '@/components/organisms/searchContactLens/SearchContactLens4.vue'
import SearchContactLens5 from '@/components/organisms/searchContactLens/SearchContactLens5.vue'
import SearchContactLensParent from '@/components/organisms/searchContactLens/SearchContactLensParent.vue'
import UserReviewArea from '@/components/organisms/user-review/UserReviewArea.vue'
import { freeContentPageComponents, sideBarComponents } from '@/components/routes/free-content-page'
import { log } from '@/log'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import Countup from '@ajax/vue/components/atoms/Countup.vue'
import AddToCartButton from '@ajax/vue/components/organisms/addtocart/AddToCartButton.vue'
import AddToCartItemList from '@ajax/vue/components/organisms/addtocart/AddToCartItemList.vue'
import ContactLensColorVariation from '@ajax/vue/components/organisms/contact-lens/ColorVariation.vue'
import ContactLensUserSelectArea from '@ajax/vue/components/organisms/contact-lens/UserSelectArea.vue'
import ErrorModalContainer from '@ajax/vue/components/organisms/ErrorModalContainer.vue'
import RecommendItems from '@ajax/vue/components/organisms/item-detail/RecommendItems.vue'
import CategoryMenu from '@ajax/vue/components/templates/CategoryMenu.vue'
import ColorStock from '@ajax/vue/components/templates/ColorStock.vue'
import ExternalPaymentBrowserBack from '@ajax/vue/components/templates/ExternalPaymentBrowserBack.vue'
import ExternalPaymentCallback from '@ajax/vue/components/templates/ExternalPaymentCallback.vue'
import Favorite from '@ajax/vue/components/templates/Favorite.vue'
import ItemRequestResultModal from '@ajax/vue/components/templates/item-detail/ItemRequestResultModal.vue'
import Itemlist from '@ajax/vue/components/templates/Itemlist.vue'
import Refine from '@ajax/vue/components/templates/Refine.vue'
import Search from '@ajax/vue/components/templates/Search.vue'
import SearchKeyword from '@ajax/vue/components/templates/SearchKeyword.vue'
import Sort from '@ajax/vue/components/templates/Sort.vue'

const topComponents = {
  category: CategoryMenu,
}

const contactLensComponents = {
  'contact-lens-color-variation': ContactLensColorVariation,
  'contact-lens-user-select-area': ContactLensUserSelectArea,
}

const condition = getConditionView()

const itemDetailComponents = {
  favorite: Favorite,
  stock: ColorStock,
  share: Share,
  recently: RecentlyViewed,
  'recommend-items': RecommendItems,
  'add-to-cart-item-list': AddToCartItemList,
  'add-to-cart-button': AddToCartButton,
  image: ImageWithBadgeBand,
  'sub-image': ImageWithBorder,
  video: Video,
  'video-thumbnail': VideoThumbnail,
  'error-modal-container': ErrorModalContainer,
  'user-review-area': UserReviewArea,
  'paid-membership-price': PaidMembershipPrice,
  'item-rating': ItemRating,
  'item-request-result-modal': ItemRequestResultModal,
  'bundle-discount-label-with-store': BundleDiscountLabelWithStore,
  ...sideBarComponents,
  ...contactLensComponents,
}

const itemlistComponents = {
  itemlist: Itemlist,
  condition,
  sort: Sort,
  countup: Countup,
  refine: Refine,
  image: ImageWithBadgeBand,
  'bundle-discount-label-with-store': BundleDiscountLabelWithStore,
  'item-rating': ItemRating,
  'add-to-cart-button-in-list': AddToCartButtonInListAdapterForTemplate,
  ...sideBarComponents,
}

const itemlistFilterComponents = {
  condition,
  category: CategoryMenu,
  image: ImageWithBadgeBand,
}

const itemlistSearchComponents = {
  countup: Countup,
  itemlist: Itemlist,
  condition,
  image: ImageWithBadgeBand,
  sort: Sort,
  'bundle-discount-label-with-store': BundleDiscountLabelWithStore,
  'item-rating': ItemRating,
  'add-to-cart-button-in-list': AddToCartButtonInListAdapterForTemplate,
  ...sideBarComponents,
}

const itemlistRecommendedComponents = {
  image: ImageWithBadgeBand,
  ...sideBarComponents,
}

const bundlePurchaseComponents = {
  image: ImageWithBadgeBand,
  'bundle-purchase-container': BundlePurchaseContainer,
  ...sideBarComponents,
}

const magazineComponents = {
  image: ImageWithBadgeBand,
  ...sideBarComponents,
}

const featureComponents = {
  image: ImageWithBadgeBand,
  ...sideBarComponents,
}

const brandGroupArticleDetailComponents = {
  share: Share,
  image: ImageWithBadgeBand,
  'add-to-cart-button': AddToCartButton,
}

const brandArticleDetailComponents = {
  share: Share,
  image: ImageWithBadgeBand,
  'add-to-cart-button': AddToCartButton,
  ...sideBarComponents,
}

const brandItemlistSearchComponents = {
  searchkeyword: SearchKeyword,
  search: Search,
  'bundle-discount-label-with-store': BundleDiscountLabelWithStore,
}

const searchContactLensComponents = {
  'search-contact-lens': SearchContactLensParent,
}

const searchContactLensChildren = [
  { path: '2', name: '2', component: SearchContactLens2 },
  { path: '4', name: '4', component: SearchContactLens4 },
  { path: '5', name: '5', component: SearchContactLens5 },
]

const commonRoutes: RouteConfig[] = [
  { path: '/magazine', components: magazineComponents },
  { path: '/feature', components: featureComponents },
  {
    path: '/external_payment/*',
    components: {
      'external-payment-callback': ExternalPaymentCallback,
      'external-payment-browser-back': ExternalPaymentBrowserBack,
    },
  },
]

const multiInstanceRoutes: RouteConfig[] = [
  { path: '/', components: topComponents },
  { path: '/article/:shortid', components: brandGroupArticleDetailComponents },
  {
    /**
     * TODO
     * MyColor的な別インスタンスが登場したら、"mycolor"部分切り替え可能にする必要ありそう
     */
    path: '/mycolor/:page_kind',
    components: freeContentPageComponents,
  },
  {
    path: '/:brand_english_name/item/:shortid',
    components: itemDetailComponents,
    props: {
      recently: (route: Route) => ({
        brand: route.params.brand_english_name,
      }),
      'user-review-area': (route: Route) => ({
        brand: route.params.brand_english_name,
      }),
      'contact-lens-color-variation':  (route: Route) => ({
        initialSelectedColorName: route.query.color,
      }),
      'contact-lens-user-select-area':  (route: Route) => ({
        initialSelectedColorName: route.query.color,
        displayPriceMode: route.query.displayPriceMode === 'simple' ? 'simple' : undefined,
      }),
    },
  },
  { path: '/:brand_english_name/search', components: brandItemlistSearchComponents },
  { path: '/:brand_english_name/article/:id', components: brandArticleDetailComponents },
  { path: '/:brand_english_name/itemlist', components: itemlistComponents },
  { path: '/:brand_english_name/itemlist/filter', components: itemlistFilterComponents },
  { path: '/:brand_english_name/itemlist/search', components: itemlistSearchComponents },
  {
    path: '/:brand_english_name/bundle/:campaign_id',
    components: bundlePurchaseComponents,
    props: {
      'bundle-purchase-container': (route: Route) => ({
        brand: route.params.brand_english_name,
      }),
    },
  },
  {
    // Hotellovers限定なので, :brand_english_nameの部分はhlで決め打ちに.
    // path: '/:brand_english_name/search-contact-lens',
    path: '/hl/search-contact-lens',
    components: searchContactLensComponents,
    children: searchContactLensChildren,
  },
  // URLのマッチング範囲が非常に広いので、常に末尾にすること
  {
    path: '/:brand_english_name/:page_kind',
    components: freeContentPageComponents,
    props: {
      'catalog-demand': (route: Route) => ({
        brand: route.params.brand_english_name,
      }),
    },
  },
  // ブランドTOP
  { path: '/:brand_english_name', components: freeContentPageComponents },
]

const singleInstanceRoutes: RouteConfig[] = [
  { path: '/article/:shortid', components: brandArticleDetailComponents },
  { path: '/itemlist', components: itemlistComponents },
  { path: '/itemlist/filter', components: itemlistFilterComponents },
  { path: '/itemlist/search', components: itemlistSearchComponents },
  { path: '/itemlist/recommended', components: itemlistRecommendedComponents },
  {
    path: '/bundle/:campaign_id', components: bundlePurchaseComponents,
  },
  { path: '/', components: freeContentPageComponents },
  {
    path: '/item/:shortid',
    components: itemDetailComponents,
    props: {
      recently: () => ({
        brand: InstanceResolver.getSingleBrand(),
      }),
      'user-review-area': () => ({
        brand: InstanceResolver.getSingleBrand(),
      }),
      'contact-lens-color-variation':  (route: Route) => ({
        initialSelectedColorName: route.query.color,
      }),
      'contact-lens-user-select-area':  (route: Route) => ({
        initialSelectedColorName: route.query.color,
        displayPriceMode: route.query.displayPriceMode === 'simple' ? 'simple' : undefined,
      }),
    },
  },
  {
    path: '/search-contact-lens',
    components: searchContactLensComponents,
    children: searchContactLensChildren,
  },
  { path: '*', components: freeContentPageComponents },
]

function makeRoutes(): RouteConfig[] {
  if (InstanceResolver.isSingle()) {
    return [
      ...commonRoutes,
      ...singleInstanceRoutes,
    ]
  }

  return [
    ...commonRoutes,
    ...multiInstanceRoutes,
  ]
}

const router = new Router({
  mode: 'history',
  routes: makeRoutes(),
})

router.beforeEach((to, _from, next) => {
  const brandEnglishName =
    BrandRouteResolver.resolveBrandFromPathElement(to.params.brand_english_name) || null

  SessionService.getInstance().keep(to.path)

  /**
   * Vue Componentの生成を妨げないよう、非同期メソッドsendPcpAnalyticsLogは await しない
   * @see https://github.com/my-color/growthpalette-front/pull/7821
   */
  sendPcpAnalyticsLog(brandEnglishName).catch((err) => {
    log.error(err)
  })

  next()
})

export default router
